import { Link } from '@tanstack/react-router';
import { CircleArrowLeft, Loader2 } from 'lucide-react';

import { useGetClassListView } from '~entities/studios/api/class-list-view';

import { ClassListTable } from './class-list-table';

export const ClassListPage = () => {
  const { data: savedView, isPending } = useGetClassListView();

  return (
    <div className=''>
      <Link to='/dashboard' className='flex w-max items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>All Classes</h2>
      </Link>
      <div className='mt-4 border-t pt-8'>
        {isPending ? (
          <div className='flex justify-center py-12' aria-label='Loading classes'>
            <Loader2 className='size-6 animate-spin' />
          </div>
        ) : (
          <ClassListTable savedView={savedView ?? null} />
        )}
      </div>
    </div>
  );
};
